import { render, staticRenderFns } from "./EvidenceInfo.vue?vue&type=template&id=46b60ee3&scoped=true&"
import script from "./EvidenceInfo.vue?vue&type=script&lang=ts&"
export * from "./EvidenceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./EvidenceInfo.vue?vue&type=style&index=0&id=46b60ee3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b60ee3",
  null
  
)

export default component.exports